(function () {
  'use strict';

  if (window.WFAWholesaleControlsLoaded) return;
  window.WFAWholesaleControlsLoaded = true;

  var controlsSelector = '[data-wholesale-controls]';

  function getElements(controls) {
    return {
      form: controls.querySelector('[data-wholesale-form]'),
      display: controls.querySelector('.wholesale-display-qty'),
      real: controls.querySelector('.wholesale-real-qty'),
      minus: controls.querySelector('.wholesale-minus'),
      cart: controls.querySelector('.wholesale-cart-btn'),
      status: controls.querySelector('.wholesale-buy-status')
    };
  }

  function getRule(controls) {
    var min = parseInt(controls.dataset.qtyMin, 10) || 1;
    var step = parseInt(controls.dataset.qtyStep, 10) || 1;
    var max = parseInt(controls.dataset.qtyMax, 10) || 0;
    if (min < 1) min = 1;
    if (step < 1) step = 1;
    return { min: min, step: step, max: max > 0 ? max : 0 };
  }

  function applyVariantRule(controls, variantId) {
    var rules = null;
    try {
      rules = JSON.parse(controls.dataset.qtyRules || '{}');
    } catch (e) {
      rules = null;
    }
    var rule = rules && rules[String(variantId)];
    if (!rule) return;
    controls.dataset.qtyMin = rule[0] || 1;
    controls.dataset.qtyStep = rule[1] || 1;
    controls.dataset.qtyMax = rule[2] || '';
  }

  function nextQuantity(controls, quantity, direction) {
    var rule = getRule(controls);
    var next;
    if (direction > 0) {
      next = quantity < rule.min ? rule.min : quantity + rule.step;
      if (rule.max && next > rule.max) next = quantity < rule.min ? 0 : quantity;
    } else {
      next = quantity - rule.step;
      if (next < rule.min) next = 0;
    }
    return next;
  }

  function readQuantity(display) {
    var value = parseInt(
      display && display.value ? display.value : '0',
      10
    );

    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function setQuantity(controls, quantity) {
    var elements = getElements(controls);
    var nextQuantity = Math.max(
      0,
      parseInt(quantity || 0, 10) || 0
    );

    var isLoading = controls.classList.contains('is-loading');

    if (elements.display) {
      elements.display.value = String(nextQuantity);
    }

    if (elements.real) {
      elements.real.value = String(nextQuantity);
    }

    if (elements.minus) {
      elements.minus.disabled =
        nextQuantity === 0 || isLoading;
    }

    if (elements.cart) {
      elements.cart.disabled =
        nextQuantity === 0 || isLoading;
    }

    controls.classList.toggle(
      'has-quantity',
      nextQuantity > 0
    );

    if (elements.status && !isLoading) {
      elements.status.textContent =
        nextQuantity > 0
          ? nextQuantity +
            (nextQuantity > 1
              ? ' boîtes sélectionnées'
              : ' boîte sélectionnée')
          : '';
    }
  }

  function finishRequest(controls, resetQuantity) {
    var elements = getElements(controls);

    controls.classList.remove('is-loading');

    if (elements.form) {
      elements.form.removeAttribute('aria-busy');
      delete elements.form.dataset.wfaSubmitting;
    }

    if (resetQuantity) {
      setQuantity(controls, 0);

      if (elements.status) {
        elements.status.textContent =
          'Produit ajouté au panier';
      }
    } else {
      setQuantity(
        controls,
        readQuantity(elements.display)
      );
    }
  }

  function initializeControls(scope) {
    var root = scope || document;

    root
      .querySelectorAll(controlsSelector)
      .forEach(function (controls) {
        var elements = getElements(controls);

        setQuantity(
          controls,
          readQuantity(elements.display)
        );
      });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var button = event.target.closest(
      '[data-wholesale-action]'
    );

    if (!button) return;

    var controls = button.closest(controlsSelector);

    if (
      !controls ||
      controls.classList.contains('is-loading')
    ) {
      return;
    }

    var elements = getElements(controls);
    var quantity = readQuantity(elements.display);
    var action = button.getAttribute(
      'data-wholesale-action'
    );

    if (action === 'increase') {
      quantity = nextQuantity(controls, quantity, 1);
    }

    if (action === 'decrease') {
      quantity = nextQuantity(controls, quantity, -1);
    }

    setQuantity(controls, quantity);
  });

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;

    var variantSelector = event.target.closest(
      '.product-card select[name="id"], ' +
      '.product-card input[name="id"]:checked'
    );

    if (!variantSelector) return;

    var card = variantSelector.closest('.product-card');

    if (!card) return;

    var variantId = variantSelector.value;

    if (!variantId) return;

    card
      .querySelectorAll(controlsSelector)
      .forEach(function (controls) {
        controls.dataset.variantId = variantId;
        applyVariantRule(controls, variantId);

        controls
          .querySelectorAll('.wholesale-variant-id')
          .forEach(function (input) {
            input.value = variantId;
          });

        setQuantity(controls, 0);
      });
  });

  document.addEventListener('submit', function (event) {
    if (!(event.target instanceof Element)) return;

    var form = event.target.closest(
      '.wholesale-buy-form'
    );

    if (!form) return;

    var controls = form.closest(controlsSelector);

    if (!controls) return;

    var elements = getElements(controls);

    var quantity = parseInt(
      elements.real && elements.real.value
        ? elements.real.value
        : '0',
      10
    ) || 0;

    if (quantity < 1) {
      event.preventDefault();
      return;
    }

    controls.classList.add('is-loading');
    form.dataset.wfaSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');

    if (elements.minus) {
      elements.minus.disabled = true;
    }

    if (elements.cart) {
      elements.cart.disabled = true;
    }

    if (elements.status) {
      elements.status.textContent =
        'Ajout au panier en cours';
    }
  });

  window.addEventListener('themeCartOpened', function () {
    document
      .querySelectorAll(
        '.wholesale-buy-form[data-wfa-submitting="true"]'
      )
      .forEach(function (form) {
        var controls = form.closest(controlsSelector);

        if (controls) {
          finishRequest(controls, true);
        }
      });
  });

  window.addEventListener('showAlert', function () {
    document
      .querySelectorAll(
        '.wholesale-buy-form[data-wfa-submitting="true"]'
      )
      .forEach(function (form) {
        var controls = form.closest(controlsSelector);

        if (controls) {
          finishRequest(controls, false);
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeControls(document);
      }
    );
  } else {
    initializeControls(document);
  }

  window.addEventListener('pageshow', function () {
    initializeControls(document);
  });
})();